
export function setProduct (state, product) {

	product.quantity = 1
	product.total = product.price.price
	state.selectedProduct = product

	state.related = product.related_products
	state.imagen = product.products_attachments == '' ? product.brand.image : product.products_attachments[0].src
}

export function setProductsAttachments (state, products_attachments) {
	products_attachments.map(pa => {
        const encodedSrc = encodeURI(pa.src).replace(/#/g, '%23');
        const encodedThump = encodeURI(pa.thumb).replace(/#/g, '%23');

        pa.src = getApiDomain() + encodedSrc;
        pa.thumb = getApiDomain() + encodedThump;
	})
	state.products_attachments_carrusel = products_attachments;
  }
/**
 * Establecer un valor para la variable imagen.
 */
export function setImagen(state, imagen) {
    state.imagen = imagen;
}

/**
 * Establecer un valor para la variable selectedProduct.
 */
export function setSelectedProduct(state, selectedProduct) {
    state.selectedProduct = selectedProduct;
}

export function setProductCant (state, product) {
	state.selectedProduct.quantity = product.quantity
}

export function setRelated (state, related) {
	related.forEach(p => {
		p.quantity = null, p.click = 0, p.total = p.price.price, p.add = false
	});
	state.related = related
}

export function productError (state, payload) {
	state.error = true
	state.errorMessage = payload
	state.products = []
}

export function setBrands (state, brands) {
	state.brands = brands.map(p => {
		return { value: p.id, label: p.description, imagen: p.thumbnails }
	})
}
export function setCategories (state, categories) {
	state.categories = categories.map(p => {
		return { value: p.id, label: p.description }
	})
}
export function setGroups (state, groups) {
	state.groups = groups.map(p => {
		return { value: p.id, label: p.subline_description }
	})
}



// WEBPACK FOOTER //
// ./src/b2b/modules/product-detail/mutations.js